import React from 'react';
import { formatTranslation } from 'intl';
import { CommonTranslationKeys, NotificationTranslationKeys } from 'intl/keys';
import { InfoBanner } from 'components/general/InfoBanner';
import BrokenLink from 'assets/icons/broken_link.svg';
import Download from 'assets/icons/download.svg';
import ReportNotFound from 'assets/icons/report_not_found.svg';
import { ButtonContained } from 'components/general';
import { useIntl } from 'react-intl';
import useIsMobile from 'hooks/useIsMobile';
import { useSharedResourceDownload } from 'components/common/withSharedResourceDownload/withSharedResourceDownload';
import { SharedResourceType } from 'components/common/withSharedResourceDownload/types';

const linkExpiredMessageId: Record<SharedResourceType, string> = {
  report: 'report_link_expired_info',
  document: 'document_link_expired_info',
};

const notFoundMessageId: Record<SharedResourceType, string> = {
  report: 'entity_not_found_report_title',
  document: 'entity_not_found_document_title',
};

export function DownloadingInfo(): React.ReactElement {
  const intl = useIntl();
  const { downloadSignedRequest } = useSharedResourceDownload();
  const isMobile = useIsMobile();

  return (
    <InfoBanner
      dataQa='downloading-info'
      messageId={
        isMobile ? 'downloading_info_web_mobile' : 'downloading_info'
      }
      icon={Download}
    >
      <p>{formatTranslation(intl, CommonTranslationKeys.downloadClickButtonPrompt)}</p>
      <ButtonContained onClick={downloadSignedRequest}>
        {formatTranslation(intl, CommonTranslationKeys.download)}
      </ButtonContained>
    </InfoBanner>
  );
}
export function LinkExpiredInfo(): React.ReactElement {
  const { entityType } = useSharedResourceDownload();
  return (
    <InfoBanner
      dataQa='link-expired-info'
      messageId={linkExpiredMessageId[entityType]}
      icon={BrokenLink}
    />
  );
}
export function NotFoundInfo(): React.ReactElement {
  const { entityType } = useSharedResourceDownload();
  return (
    <InfoBanner
      dataQa='report-not-found-info'
      messageId={notFoundMessageId[entityType]}
      icon={ReportNotFound}
    />
  );
}
export function DownloadFailedInfo(): React.ReactElement {
  return (
    <InfoBanner
      dataQa='download-failed-info'
      messageId={NotificationTranslationKeys.somethingWentWrong}
      icon={BrokenLink}
    />
  );
}
